<template>
	<div>
		<div id='header'>
			<div class="side-container">
				<a href="https://www.id-photo-verify.com/" target="_blank"><img src="../assets/logo.png" id='logo'></a>
				<a href="#"><div class="tab-link chosen">首页</div></a>
				<a href="https://www.91pitu.com/standardH5/" target="_blank"><div class="tab-link">体验链接</div></a>
				<!-- <div class="tab-link">成功案例</div> -->
			</div>
			<div class="side-container">
				<router-link to="/login"><div id='logo-button' class="header-button">登录</div></router-link>
				<router-link to="/register"><div id='register-button' class="header-button">注册</div></router-link>
				<div id='contact-phone' >
					<img src="../assets/icon_call_index.png">联系电话 18014955375
				</div>
			</div>
		</div>
		<div id='main'>
			<div>
				<div id='main-title'>
					<p>零门槛快速搭建</p>
					<p>教育考试报名证件照制作网站</p>
				</div>
				<div id='sub-title'>全国教育报名证件照规格 | 报名照片审核工具包通过 | 精准高效获取考生信息</div>
				<div id='main-button-container'>
					<a href="https://www.91pitu.com/standardH5/" target="_blank"><div id='experience-button'>点击立即体验</div></a>
					<router-link to="/register"><div id='register-button2'>立即注册</div></router-link>
				</div>
			</div>
			<img id='main-img' src="../assets/img_1@2x.png" />
		</div>
		<div id='footer'>
			<div id='footer-title'>接入流程</div>
			<div id='step-container'>
				<div v-for='(item,index) in steps' :key='index' class="step">
					<img :src="item.numImg" class="step-no">
					<img :src="item.mainImg" class="step-img">
					<div class="step-text">{{item.name}}</div>
				</div>
			</div>
			<router-link to="/register"><div id='register-button3'>立即注册</div></router-link>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			steps:[{
				numImg:require("../assets/1@2x.png"),
				mainImg:require("../assets/icon_register@2x.png"),
				name:"完成账号注册"
			},{
				numImg:require("../assets/2@2x.png"),
				mainImg:require("../assets/icon_tool@2x.png"),
				name:"选择开发方式"
			},{
				numImg:require("../assets/3@2x.png"),
				mainImg:require("../assets/icon_info@2x.png"),
				name:"填写必要信息"
			},{
				numImg:require("../assets/4@2x.png"),
				mainImg:require("../assets/icon_link@2x.png"),
				name:"将代码或者链接放在自己的官网即可"
			}]
		}
	}
}
</script>

<style scoped="scoped">
	a{
		text-decoration: none;
	}
	#header{
		width: 100%;
		height: 66px;
		background: #3173FF;
		padding-left: 2.6vw;
		padding-right: 6.25vw;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-direction: row;
	}
	.side-container{
		display: flex;
		align-items: center;
		flex-direction: row
	}
	#logo{
		width: 140px;
		height: 40px;
		margin-right: 10px;
	}
	.tab-link{
		width:100px;
		height: 66px;
		line-height: 66px;
		font-size: 16px;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.8);
		margin-right: 20px;
		text-align: center;
	}
	.tab-link.chosen{
		font-weight: 600;
		border-bottom:2px #fff solid;
		color: rgba(255, 255, 255, 1);
	}
	.header-button{
		width: 100px;
		height: 40px;
		border-radius: 6px;
		line-height: 40px;
		color: #FFFFFF;
		font-weight: 500;
		font-size: 16px;
		text-align: center;
		margin-right: 24px;
	}
	#logo-button{
		background: rgba(255, 255, 255, 0.1);
		border: 1px solid #FFFFFF;
	}
	#register-button{
		background: #40D3FF;
	}
	#contact-phone{
		color: rgba(255, 255, 255, 0.8);
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	#contact-phone>img{
		width: 22px;
		height: 22px;
		margin-right: 6px;
	}
	#main{
		background-image: url(../assets/bg_line@2x.png);
		background-position: bottom;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 110px;
		padding-bottom: 124px;
	}
	#main-title{
		font-size: 40px;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 56px;
	}
	#sub-title{
		font-size: 24px;
		font-weight: 500;
		color: #E9F4FF;
		margin-top: 24px;
	}
	#main-button-container{
		display: flex;
		align-items: center;
		margin-top: 64px;
	}
	#experience-button{
		background-image: url(../assets/btn@2x.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 270px;
		height: 90px;
		line-height: 85px;
		text-align: center;
		font-size: 20px;
		font-weight: 500;
		color: #FFFFFF;
	}
	#register-button2{
		width: 180px;
		height: 70px;
		line-height: 70px;
		text-align: center;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 10px;
		border: 1px solid #FFFFFF;
		font-size: 20px;
		font-weight: 500;
		color: #FFFFFF;
		/* 下面的代码是为了抵消隔壁按钮背景图切图的误差 */
		position: relative;
		bottom: 3px;
	}
	#main-img{
		width:42.7vw;
		display: block;
	}
	#footer{
		background-color: #F6F9FF;
		background-image: url(../assets/element@2x.png);
		background-position: bottom;
		background-repeat: no-repeat;
		background-size: 100% auto;
		padding-top: 90px;
		padding-bottom: 98px;
	}
	#footer-title{
		font-size: 40px;
		font-weight: 600;
		color: #303439;
		text-align: center;
	}
	#step-container{
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: center;
		margin-top: 70px;
	}
	.step{
		width: 360px;
		height: 424px;
		background: #FFFFFF;
		box-shadow: 0px 10px 20px 2px #EEF4FF;
		border-radius: 20px;
		margin-left: 26px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.step-no{
		width: 50px;
		height: 50px;
	}
	.step-img{
		width: 120px;
		height: 120px;
		margin-top: 50px;
	}
	.step-text{
		font-size: 24px;
		font-weight: 400;
		color: #7B838E;
		line-height: 40px;
		height: 80px;
		margin-top: 37px;
		width: 200px;
		text-align: center;
	}
	#register-button3{
		background-image: url(../assets/btn备份@2x.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 270px;
		height: 90px;
		line-height: 85px;
		text-align: center;
		font-size: 20px;
		font-weight: 500;
		color: #FFFFFF;
		margin: 74px auto 0;
	}
</style>
